import type { ChangeEvent, FC, ReactNode } from "react";

type InputGroupProps = {
  label?: ReactNode;
  value?: string | number;
  onChange?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  type?: string;
  placeholder?: string;
  required?: boolean;
  as?: "input" | "textarea";
  children?: ReactNode;
  name?: string;
  maxLength?: number;
  error?: boolean;
  errorMessage?: string | null;
  disabled?: boolean;
};

export const InputGroup: FC<InputGroupProps> = ({
  label,
  value,
  onChange,
  type = "text",
  placeholder,
  required,
  as = "input",
  children,
  name,
  maxLength,
  error = false,
  errorMessage,
  disabled,
}) => (
  <div>
    {label && (
      <label
        className="font-ambit text-[0.9375rem] not-italic font-normal leading-[1.25rem] text-secondary"
        htmlFor={name}
      >
        {label}
        {required && "*"}
      </label>
    )}
    {children ? (
      <div>{children}</div>
    ) : as === "textarea" ? (
      <textarea
        className={`h-[8.3125rem] w-full rounded-2xl border px-4 py-3 font-ambit text-[0.9375rem] not-italic font-normal leading-[1.25rem] transition-colors ${label ? "mt-2" : ""} ${error ? "border-[#F04438] bg-[#FEE4E2]" : "border-primary/20 bg-[#F0F5F7] focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/10"}`}
        value={value}
        onChange={onChange as (e: ChangeEvent<HTMLTextAreaElement>) => void}
        placeholder={placeholder}
        name={name}
        maxLength={maxLength}
      />
    ) : (
      <input
        className={`min-h-[2.75rem] w-full rounded-2xl border px-4 py-2 font-ambit text-[0.9375rem] not-italic font-normal leading-[1.25rem] transition-colors ${label ? "mt-2" : ""} ${error ? "border-[#F04438] bg-[#FEE4E2]" : "border-primary/20 bg-[#F0F5F7] focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/10"}${disabled ? " opacity-50" : ""}`}
        type={type}
        value={value}
        onChange={onChange as (e: ChangeEvent<HTMLInputElement>) => void}
        placeholder={placeholder}
        required={required}
        name={name}
        maxLength={maxLength}
        disabled={disabled}
      />
    )}
    {error && errorMessage && (
      <div className="mt-1 font-ambit text-[0.9375rem] text-[#F04438]">
        {errorMessage}
      </div>
    )}
  </div>
);
